<template>
  <div class="container-withdraw-account" :style="cssVars()">
    <div class="custom-nav-block" :style="`padding-top:${topBarHeight}px; background-color: #f7f6f9;`">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="goPrevious">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow01.webp" alt="" />
          <span class="tit-left">{{ $t('lang.WithdrawalAccount.k033') }}</span>
        </template>
      </van-nav-bar>
    </div>

    <div class="main">
      <!-- 图标 -->
      <div class="account-tit">
        <div class="account-img">
          <img :src="icon | imgPath" alt="" />
        </div>
        <span class="line"></span>
        <div class="account-name">{{ withdrawalMethod }}</div>
      </div>

      <!-- 提现国家 -->
      <div class="select">
        <span>{{ $t('lang.BaseModule.k015') }}</span>
        <div class="country">
          <img :src="locaFlag | imgPath" alt="" />
          <div class="account-name">{{ locaCode }}</div>
        </div>
      </div>

      <div class="select">
        <span>{{ $t('lang.BaseModule.k041') }}</span>
        <input style="color: #333" type="text" :placeholder="$t('lang.WithdrawalAccount.k028')" v-model.trim="accountName" />
      </div>

      <div class="select">
        <span type="text">
          {{ $t('lang.WithdrawalAccount.k022') }}
        </span>
        <div class="select-account">
          <input type="text" :placeholder="$t('lang.WithdrawalAccount.k034')" v-model="accountId" />
        </div>
      </div>

      <div class="select">
        <span>{{ $t('lang.BaseModule.k005') }} (TRC20/BEP20)</span>
        <input
          style="color: #333"
          maxlength="42"
          type="text"
          :placeholder="$t('lang.BaseModule.k005')"
          v-model.trim="accountAddress"
          @input="onlyNumOrLetter($event, 'accountAddress')"
        />
      </div>
      <!-- prettier-ignore -->
      <div class="tipTRC20-a">
        * <a href="https://www.binance.com/support/faq/detail/115003764971">{{ $t('lang.WithdrawalAccount.k023') }}</a>
      </div>

      <!-- 保存按钮 -->
      <div class="save-btn" :class="{ 'forbid-submit': this.submitBtnStatus() }" @click="handleSave">
        {{ $t('lang.BaseModule.k051') }}
      </div>
    </div>
  </div>
</template>

<script>
import { apiBindWithdrawAccount, apiEditWithdrawAccount } from '@/api/imee.js'
import { isEmail } from '@/utils/common.js'

import _debounce from 'lodash/debounce'
import baseMixin from '../base.mixin.js'

export default {
  mixins: [baseMixin],
  data() {
    return {}
  },
  methods: {
    // 保存
    handleSave: _debounce(
      function () {
        // 去掉空格
        const strAccountId = `${this.accountId}`
        this.accountId = strAccountId.replace(/\s*/g, '')

        const data = {
          accountId: this.accountId,
          accountName: this.accountName,
        }

        // 判断emoji表情
        if (this.hasEmojiCharacter(this.accountName)) {
          this.accountName = ''
          // lang.WithdrawalAccount.k036: "Does not support emoji input"
          this.$client.showToast(this.$t('lang.WithdrawalAccount.k036'))
          return
        }

        // 验证邮箱格式
        if (this.withdrawalMethod === 'USDT(BINANCE)') {
          if (!isEmail(this.accountId)) {
            this.accountId = ''
            // lang.WithdrawalAccount.k037: "Wrong format. Please enter your {n0} email address"
            this.$client.showToast(this.replaceOneText(this.$t('lang.WithdrawalAccount.k037'), '{n0}', 'Binance'))
            return
          }
        }

        if (this.withdrawalMethod === 'USDT(BINANCE)') {
          if (![34, 42].includes(this.accountAddress.length)) {
            this.accountAddress = ''
            // lang.WithdrawalAccount.k042: "TRC20 address is 34 characters long, BEP20 address is 42 characters long"
            this.$client.showToast(this.$t('lang.WithdrawalAccount.k042'))
            return
          }

          // 地址开头校验
          if (!/^(T|0x).*/.test(this.accountAddress)) {
            this.accountAddress = ''
            // lang.WithdrawalAccount.k041: "TRC20 starts with T, BEP20 starts with 0x"
            this.$client.showToast(this.$t('lang.WithdrawalAccount.k041'))
            return
          }

          // TRC20字符集校验
          if (this.accountAddress.length === 34 && /^T/.test(this.accountAddress) && !/^[A-Za-z0-9]+$/.test(this.accountAddress)) {
            this.accountAddress = ''
            // lang.WithdrawalAccount.k039: "The TRC20 address only supports letters and numbers"
            this.$client.showToast(this.$t('lang.WithdrawalAccount.k039'))
            return
          }

          // BEP20字符集校验
          if (this.accountAddress.length === 42 && /^0x/.test(this.accountAddress) && !/^[0-9a-f]+$/i.test(this.accountAddress.slice(2))) {
            this.accountAddress = ''
            // lang.WithdrawalAccount.k040: "The BEP20 address only supports lowercase letters and numbers"
            this.$client.showToast(this.$t('lang.WithdrawalAccount.k040'))
            return
          }

          data.accountAddress = this.accountAddress
        }

        // edit
        if (this.cfgId) {
          apiEditWithdrawAccount(data, this.cfgId).then((res) => {
            if (res.status === 200) {
              this.$client.showToast(res.message)
              const timer = setTimeout(() => {
                clearTimeout(timer)
                this.jumpWithdrawal()
              }, 500)
            }
          })
        }
        // add
        else {
          data.withdrawalMethod = this.withdrawalMethod
          apiBindWithdrawAccount(data).then((res) => {
            if (res.status === 200) {
              this.$client.showToast(res.message)
              const timer = setTimeout(() => {
                clearTimeout(timer)
                this.jumpWithdrawal()
              }, 500)
            }
          })
        }
      },
      3000,
      {
        leading: true,
        trailing: false,
      }
    ),
    // 保存校验
    submitBtnStatus() {
      if (this.withdrawalMethod === 'USDT(BINANCE)') {
        if (this.accountAddress) {
          return true
        }
        return false
      }

      return false
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../base.scss';
</style>
